import React from 'react';
import Form from 'react-bootstrap/Form';
import FormHelpTooltip from '@/components/utils/FormHelpTooltip';
import i18n from 'i18n';
import {FormikProps} from 'formik';
import {EvaluationTask} from '@/views/admin/channel/types';

type Props = {
    formik: FormikProps<EvaluationTask>;
};

const EvaluationTaskRepetitiveCallsFormFields: React.FC<Props> = React.memo(({formik}) => {
    return (
        <>
            <Form.Group className="mb-3" controlId="params.period" >
                <Form.Label>
                    {i18n.t('jt_period_days.text')}
                    <FormHelpTooltip>
                        {i18n.t('jt_repetitive_calls.text')}
                    </FormHelpTooltip>
                </Form.Label>
                <Form.Control
                    type="number"
                    name="params.period"
                    required
                    min={0}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.params.period ?? 0}
                    isInvalid={(
                        formik.touched.params?.period &&
                        !!formik.errors.params?.period
                    ) || (formik.values.params.period ?? 0) < 0}
                />
                <Form.Control.Feedback
                    type="invalid"
                    style={{
                        display:
                            formik.touched.params?.period &&
                                formik.errors.params?.period
                                ? 'block'
                                : 'none',
                    }}
                >
                    {formik.errors.params?.period}
                </Form.Control.Feedback>
            </Form.Group >
        </>
    );
});

export default EvaluationTaskRepetitiveCallsFormFields; 